export default "__VITE_ASSET__3e7546e7__"